import {IComponentOptions} from "angular";

export const InvalidStatusComponent: IComponentOptions = {
    bindings: {
        message: "<"
    },
    template: require("./invalid-status.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/invalid-status/invalid-status.component.ts